import styled from 'styled-components';
import { Text } from '@naf/text';
import { IconButton } from '@naf/icon-button';
import { breakpoints, spacing } from '@naf/theme';

export const Header = styled(Text)`
  margin: 0;
  grid-column: 3 / -3;
  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;

export const Wrapper = styled.div`
  grid-column: 2 / -2;
  margin-bottom: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
  position: relative;
  display: flex;
  align-items: center;

  :before {
    @media (max-width: ${breakpoints.m}) {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 100%;
      z-index: 2;
    }
  }

  :after {
    @media (max-width: ${breakpoints.m}) {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 100%;
      z-index: 2;
    }
  }

  @media (max-width: ${breakpoints.m}) {
    margin-left: -${spacing.space32};
    margin-right: -${spacing.space32};
  }
`;

export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  padding-left: ${spacing.space16};
  padding-right: ${spacing.space16};

  @media (min-width: ${breakpoints.m}) {
    margin-left: ${spacing.space48};
    margin-right: ${spacing.space48};
  }

  // Remove scrollbar
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ArticleCarousel = styled.div`
  display: flex;
  width: fit-content;
  scroll-snap-type: x proximity;
  scroll-margin: 0 64px;
`;

export const StyledArrowLeft = styled(IconButton)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
  position: absolute;
  left: 0;
  z-index: 3;
`;

export const StyledArrowRight = styled(IconButton)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
  position: absolute;
  right: 0;
  z-index: 3;
`;
